export default {
	methods: {
		setCookie: function (key, value, validFor) {
			if (!key || !value) {
				return;
			}
			let cookieString = key + '=' + value;

			if (validFor) {
				let date = new Date();
				date.setDate(date.getDate() + +validFor);
				cookieString += '; expires=' + date;
			}

			document.cookie = cookieString;
		},
		getCookie: function (key) {
			let value = '; ' + document.cookie;
			let parts = value.split('; ' + key + '=');
			if (parts.length === 2) {
				return parts
					.pop()
					.split(';')
					.shift();
			}
		},
		deleteCookie: function (key) {
			document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
		}
	}
};
